import React from 'react';
import { IFrame } from 'src/components/organisms/IFrame';
import { configVars } from 'src/helpers/configVars';
import { useUserFeature } from 'src/hooks';
import { ShowState } from 'src/components/molecules/ShowState';
import * as S from './styles';

const QueueHealthPage: React.FC = () => {
  const hasQueueHealthAccess = useUserFeature('queue_health');

  if (!hasQueueHealthAccess) {
    return (
      <S.Container>
        <ShowState
          type="information"
          variant="error"
          message="You do not have permission to access Queue Health."
        />
      </S.Container>
    );
  }

  return (
    <S.Container>
      <S.DashboardContainer data-testid="queue-health-dashboard">
        <IFrame url={configVars.data_dog.queue_health_embed_url} title="Queue Health" />
      </S.DashboardContainer>
    </S.Container>
  );
};

export default QueueHealthPage;
